import { render, staticRenderFns } from "./McfHeaderDetails.vue?vue&type=template&id=55e0b512"
import script from "./McfHeaderDetails.vue?vue&type=script&lang=js"
export * from "./McfHeaderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports